import Swal from "sweetalert2"

const timer = 3000, timerProgressBar = true
const defaultCustomClass = {
    confirmButton: 'btn btn-primary',
    denyButton: 'btn btn-success ml-1',
    cancelButton: 'btn btn-danger ml-1'
}

const defaultTimer = {
    timer,
    timerProgressBar,
    customClass: defaultCustomClass
}

const defaultConfirm = {
    title: '¡Eliminando...!',
    text: '¡El registro esta siendo eliminado!',
    icon: 'success',
    ...defaultTimer
}

const defaultCancel = {
    title: '¡Cancelado!',
    text: '¡El registro está a salvo!',
    icon: 'error',
    ...defaultTimer
}

const defaultConfig = {
    width: 700,
    showCancelButton: true,
    showDenyButton: false,
    cancelButtonText: 'Cancelar',
    denyButtonText: '',
    confirmButtonText: 'Si, eliminalo'
}

export const handleGenericSwal = async ({ title, text, icon, configuration = {}, confirm = {}, cancel = {}, deny = {} }) => {
    const swalHeader = {
        title: title || '¿Estás seguro que quieres eliminar el registro?',
        text: text || '¡No vas a poder revertir los cambios!',
        icon: icon || 'warning'
    }

    const result = await Swal.fire({
        ...swalHeader,
        ...defaultConfig,
        ...configuration,
        customClass: defaultCustomClass
    })
    if (result.isConfirmed) {
        Swal.fire({ ...defaultConfirm, ...confirm })
        return { confirm: true }
    } else if (result.isDenied) {
        Swal.fire({ ...defaultCancel, ...deny })
        return { confirm: true, deny: true }
    } else if (result.isDismissed) {
        Swal.fire({ ...defaultCancel, ...cancel })
        return { confirm: false }
    }
}